"use client";

import { useEffect, useRef } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { AppConfig } from "~/utils/AppConfig";
import { APP_VERSION } from "~/services/api/config";
import useUserId from "~/hooks/useUserId";

export const DataDog = () => {
    const { userId } = useUserId();
    const userIdRef = useRef(userId);
    userIdRef.current = userId;

    useEffect(() => {
        if (!AppConfig.isProduction) {
            return;
        }

        datadogRum.init({
            applicationId: "d3d209dc-d5ea-49f5-867e-ee1246f30030",
            clientToken: "pub3325fb62d37e451430d9bf999d066474",
            // `site` refers to the Datadog site parameter of your organization
            // see https://docs.datadoghq.com/getting_started/site/
            site: "datadoghq.com",
            service: "innerbalance",
            env: "prod",
            version: APP_VERSION,
            sessionSampleRate: 100,
            sessionReplaySampleRate: 100,
            trackBfcacheViews: true,
            defaultPrivacyLevel: "mask-user-input",
            beforeSend: (event) => {
                event.context = event.context || {};
                event.context.user = {
                    ...(event.context.user || {}),
                    id: userIdRef.current,
                };
                return true
            },
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return null;
};
